export default __webpack_public_path__ + "static/media/tailwind.daf77586.jpg";